import { mapValues } from '@exodus/basic-utils';
import selectorDefinitions from './selectors/index.js';
const initialState = {
    availableAssetNamesByWalletAccount: {},
};
const eventReducers = {
    availableAssetNamesByWalletAccount: (state, data) => ({
        ...state,
        availableAssetNamesByWalletAccount: mapValues(data, (assetNames) => new Set(assetNames)),
    }),
};
const assetSourcesReduxDefinition = {
    id: 'assetSources',
    type: 'redux-module',
    initialState,
    eventReducers,
    selectorDefinitions,
};
export default assetSourcesReduxDefinition;
